import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { getShopPage } from "../lib/api";
import { PageHero } from "../components/FormKit";

// Renders a live TAVEN page (body is sanitized HTML from the storefront) inside TAVEN branding.
export const ShopPageView = () => {
  const { handle } = useParams();
  const [page, setPage] = useState(undefined);

  useEffect(() => {
    let active = true;
    setPage(undefined);
    getShopPage(handle).then((p) => { if (active) setPage(p); }).catch(() => { if (active) setPage(null); });
    return () => { active = false; };
  }, [handle]);

  if (page === undefined) return <div className="max-w-3xl mx-auto py-24 px-4"><div className="h-10 w-2/3 skeleton mb-6" /><div className="space-y-3">{["a","b","c","d","e"].map((k) => <div key={k} className="h-4 w-full skeleton" />)}</div></div>;
  if (page === null) return <div className="max-w-3xl mx-auto py-24 text-center" data-testid="page-not-found"><h1 className="text-2xl font-display font-black">Page not found</h1><Link to="/" className="text-taven-gold mt-3 inline-block">Back to Home</Link></div>;

  return (
    <div data-testid="shop-page-view">
      <PageHero eyebrow="TAVEN SYSTEM LLC" title={page.title} />
      <section className="px-4 md:px-8 lg:px-12 mx-auto max-w-3xl py-12">
        <div className="taven-richtext text-muted-foreground leading-relaxed" dangerouslySetInnerHTML={{ __html: page.body || "<p>Content coming soon.</p>" }} />
      </section>
    </div>
  );
};

export default ShopPageView;
